import { useBranding } from './BrandingProvider';

type ClientLogoProps = {
  variant?: 'full' | 'icon';
  className?: string;
};

export function ClientLogo({ variant = 'full', className }: ClientLogoProps) {
  const { branding, isLoading } = useBranding();

  if (isLoading || !branding) return null;

  const src = variant === 'full' ? branding.logoUrl : branding.logoIconUrl;
  if (!src) return null;

  return (
    <img
      src={src}
      alt={branding.companyName || 'Client'}
      className={className}
    />
  );
}
